import { useEffect, useState } from 'react';
import type { FC } from 'react';
import { useParams } from 'react-router-dom';
import OrderApi from 'src/api/OrderApi';
import { Order } from '../../types/orderList';
import Detail from 'src/components/order/OrderDetail';
import { Box, Container, Grid, Card, Tabs, Tab } from '@mui/material';
import OrderEntryTopNav from 'src/components/order/orderEntry/OrderEntryTopNav';
import useSettings from 'src/hooks/useSettings';
import OrderDetailGrid from './OrderDetailGrid';
import '../../theme/partials/order/ViewOrder.css';
import TabPanel from 'src/components/TabPanel';
import POHistoryGrid from 'src/components/dashboard/overview/OpenOrdersGrid/POHistoryGrid';
import { getSettingsWidth } from 'src/utils/settingsHelper';
import { usePOHistory } from 'src/hooks/usePOHistory';

const OrderDetail: FC<React.PropsWithChildren<unknown>> = () => {
  const { orderNumber: orderNumberParam } = useParams();
  const contentWidth = useSettings((state) => state.settings.contentWidth);
  const [tabsValue, setTabsValue] = useState(0);

  let strArr: string[] = orderNumberParam.split('-');
  let orderNumber = strArr.length > 0 ? Number(strArr[0]) : 0;
  let orderSuffix = strArr.length > 1 ? Number(strArr[1]) : 0;

  const [order, setOrder] = useState<Order>(undefined);
  const { poHistory } = usePOHistory(orderNumber);

  useEffect(() => {
    const init = async () => {
      OrderApi.getOpenOrder(orderNumber, orderSuffix).then((o) => {
        setOrder(o);
      });
    };
    document.title = 'Order Detail';
    init();
  }, []);

  const handleTabsChange = (e, newValue) => {
    setTabsValue(newValue);
  };

  return (
    <>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 2,
        }}
      >
        <Container maxWidth={getSettingsWidth(contentWidth)} className={`container-width__${contentWidth}`}>
          <Grid container spacing={2}>
            <Grid style={{ width: '100%' }} size={{ xs: 12 }}>
              <OrderEntryTopNav buttonList={['back']} />
              <Box sx={{ mb: 8 }}></Box>
              <Detail openOrder={order}></Detail>
            </Grid>
            <Grid style={{ width: '100%' }} size={{ xs: 12 }}>
              <Box>
                <Tabs value={tabsValue} onChange={handleTabsChange}>
                  {/* <Tab label="Open Documents and Invoices" /> */}
                  <Tab label="Order Details" />
                  {poHistory?.length > 0 && <Tab label="PO History" />}
                </Tabs>
              </Box>
              <TabPanel value={tabsValue} index={0}>
                <Card>{order && order.openOrderItems && <OrderDetailGrid order={order} />}</Card>
              </TabPanel>
              <TabPanel value={tabsValue} index={1}>
                {poHistory?.length > 0 && <POHistoryGrid poHistory={poHistory} />}
              </TabPanel>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default OrderDetail;
